export default __webpack_public_path__ + "assets/images/7ea32f1e63d6234f00c852f668435d24.png";